/* ==========================================================================
   Furrly storefront behaviour.
   Ported from the `class Component extends DCLogic` block in
   design/Kind Litter 4A Phone.dc.html, with the pricing maths swapped for real
   Shopify variant + selling-plan data and the mock cart swapped for /cart.js.
   No build step, no dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.FURRLY || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };

  /* --- money ------------------------------------------------------------- */
  // Mirrors Shopify's money_format so JS-rendered prices match Liquid-rendered ones.
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var value = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return group(value.toFixed(2), ',', '.');
        case 'amount_no_decimals': return group(Math.round(value).toString(), ',', '');
        case 'amount_with_comma_separator': return group(value.toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(Math.round(value).toString(), '.', ',');
        case 'amount_with_space_separator': return group(value.toFixed(2), ' ', ',');
        default: return value.toFixed(2);
      }
    });
  }
  function group(str, thousands, decimal) {
    var parts = str.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] && decimal ? int + decimal + parts[1] : int;
  }

  /* --- Scroll lock -------------------------------------------------------- */
  // overflow:hidden on <html> does not hold on iOS Safari — the page still
  // rubber-bands behind the drawer and jumps to the top on close. Pinning the
  // body and restoring the offset afterwards is the behaviour shoppers expect.
  var Lock = (function () {
    var depth = 0, y = 0;
    return {
      on: function () {
        if (depth++ > 0) return;
        y = window.scrollY || document.documentElement.scrollTop || 0;
        var b = document.body.style;
        b.position = 'fixed'; b.top = -y + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
      },
      off: function () {
        if (depth === 0 || --depth > 0) return;
        var b = document.body.style;
        b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
        window.scrollTo(0, y);
      }
    };
  })();

  /* --- Slide-out menu ---------------------------------------------------- */
  (function menu() {
    var el = $('[data-menu]');
    if (!el) return;
    var trigger = null;

    function setOpen(open) {
      el.classList.toggle('is-open', open);
      $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
      $('.f-menu__scrim', el).tabIndex = open ? 0 : -1;
      if (open) Lock.on(); else Lock.off();
      if (open) {
        var first = $('.f-menu__close', el);
        if (first) first.focus();
      } else if (trigger) {
        trigger.focus();
      }
    }

    $$('[data-menu-open]').forEach(function (b) {
      on(b, 'click', function () { trigger = b; setOpen(true); });
    });
    $$('[data-menu-close]', el).forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) setOpen(false);
    });
    // Keep tab focus inside the panel while it is open.
    on(el, 'keydown', function (e) {
      if (e.key !== 'Tab' || !el.classList.contains('is-open')) return;
      var f = $$('a[href],button:not([tabindex="-1"]),select,input', $('.f-menu__panel', el));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* --- Header hide-on-scroll ----------------------------------------------
     Hides on the way down so the page gets its full height back, and comes
     straight back on the way up. Reads are batched into rAF so a fast flick on
     mobile doesn't lay out the header on every scroll event. */
  var headerH = 0;
  (function header() {
    var el = $('[data-hide-on-scroll]');
    if (!el) return;
    var last = 0, ticking = false;

    function sync() {
      ticking = false;
      var doc = document.scrollingElement || document.documentElement;
      var y = Math.max(0, doc.scrollTop);
      headerH = el.offsetHeight;
      var delta = y - last;
      // Ignore sub-pixel jitter and iOS rubber-banding past the top.
      if (Math.abs(delta) < 5) return;
      if (y <= 90 || delta < 0) el.classList.remove('is-hidden');
      else el.classList.add('is-hidden');
      last = y;
    }

    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }, { passive: true });

    headerH = el.offsetHeight;
    on(window, 'resize', function () { headerH = el.offsetHeight; });
  })();

  /* --- In-page anchors ----------------------------------------------------
     Native #hash jumps land under the sticky header, so scroll manually with
     the header's real height as the offset. */
  on(document, 'click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id === '#' || a.hasAttribute('data-no-smooth')) return;
    var target = document.getElementById(id.slice(1));
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.scrollY - (headerH + 12);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', id);
    // Move focus without a second jump, so keyboard users land in the section.
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  /* --- Horizontal rails (UGC) -------------------------------------------- */
  $$('[data-rail]').forEach(function (rail) {
    var scope = rail.closest('section') || document;
    function step(dir) { rail.scrollBy({ left: dir * Math.round(rail.clientWidth * 0.8), behavior: 'smooth' }); }
    on($('[data-rail-prev]', scope), 'click', function () { step(-1); });
    on($('[data-rail-next]', scope), 'click', function () { step(1); });
  });

  /* --- UGC clips ----------------------------------------------------------
     Every clip starts paused and muted. Tap the tile to play or pause; the
     speaker button toggles sound independently. Starting one clip pauses the
     others so two soundtracks never overlap. */
  (function ugc() {
    var media = $$('[data-ugc]');
    if (!media.length) return;

    function pauseOthers(except) {
      media.forEach(function (m) {
        if (m === except) return;
        var v = m.querySelector('video');
        if (v && !v.paused) v.pause();
      });
    }

    media.forEach(function (m) {
      var v = m.querySelector('video');
      var play = $('[data-ugc-play]', m);
      var mute = $('[data-ugc-mute]', m);
      if (!v) return;

      v.muted = true;
      v.setAttribute('playsinline', '');           // iOS: never go fullscreen
      v.removeAttribute('autoplay');               // explicit: paused on load

      // Class lives on the media wrapper so both buttons can style off it.
      function syncPlay() {
        m.classList.toggle('is-playing', !v.paused && !v.ended);
        if (play) {
          play.setAttribute('aria-label', (v.paused ? 'Play' : 'Pause') + ' video');
        }
      }
      on(v, 'play', syncPlay);
      on(v, 'pause', syncPlay);
      on(v, 'ended', syncPlay);

      on(play, 'click', function () {
        if (v.paused) {
          pauseOthers(m);
          var p = v.play();
          // Autoplay policies reject when a clip is unmuted and there is no
          // gesture credit — fall back to muted rather than doing nothing.
          if (p && p.catch) {
            p.catch(function () {
              v.muted = true;
              syncMute();
              v.play().catch(function (err) { console.error('[furrly] clip failed to play', err); });
            });
          }
        } else {
          v.pause();
        }
      });

      function syncMute() {
        m.classList.toggle('is-muted', v.muted);
        if (mute) {
          mute.setAttribute('aria-pressed', String(v.muted));
          mute.setAttribute('aria-label', (v.muted ? 'Unmute' : 'Mute') + ' video');
        }
      }
      on(mute, 'click', function () {
        v.muted = !v.muted;
        if (!v.muted) { v.volume = 1; pauseOthers(m); }
        syncMute();
      });
      on(v, 'volumechange', syncMute);

      // Stop playback (and sound) once a clip is scrolled well out of view.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (!en.isIntersecting && !v.paused) v.pause(); });
        }, { threshold: 0.25 }).observe(m);
      }

      syncPlay();
      syncMute();
    });
  })();

  /* --- Accordions (product info + FAQ) ------------------------------------ */
  $$('[data-acc]').forEach(function (acc) {
    var multi = acc.hasAttribute('data-acc-multi');
    $$('.f-acc__item', acc).forEach(function (item) {
      var btn = $('.f-acc__btn', item);
      on(btn, 'click', function () {
        var open = item.classList.contains('is-open');
        if (!multi) {
          $$('.f-acc__item', acc).forEach(function (o) {
            o.classList.remove('is-open');
            $('.f-acc__btn', o).setAttribute('aria-expanded', 'false');
            $('.f-acc__sign', o).textContent = '+';
          });
        }
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        $('.f-acc__sign', item).textContent = open ? '+' : '−';
      });
    });
  });

  /* --- FAQ page: search, categories, expand all --------------------------- */
  (function faqPage() {
    var sec = $('[data-faq-full]');
    if (!sec) return;
    var input = $('[data-faq-search]');
    var clear = $('[data-faq-clear]');
    var wrap = input && input.closest('[data-search]');
    var items = $$('[data-faq-item]', sec);
    var empty = $('[data-faq-empty]', sec);
    var countEl = $('[data-faq-count]', sec);
    var wordEl = $('[data-faq-count-word]', sec);
    var expand = $('[data-faq-expand]', sec);
    var cat = ($$('[data-faq-cat]')[0] || {}).dataset ? $$('[data-faq-cat]')[0].dataset.faqCat : 'All';
    var allLabel = cat;

    function apply() {
      var q = (input ? input.value : '').trim().toLowerCase();
      var n = 0;
      items.forEach(function (it) {
        var okCat = cat === allLabel || it.dataset.cat === cat;
        var okText = !q || (it.dataset.text || '').indexOf(q) > -1;
        var show = okCat && okText;
        it.classList.toggle('is-hidden', !show);
        if (show) n++;
      });
      if (countEl) countEl.textContent = n;
      if (wordEl) wordEl.textContent = n === 1 ? 'question' : 'questions';
      if (empty) empty.classList.toggle('is-on', n === 0);
      if (wrap) wrap.classList.toggle('has-val', !!q);
    }

    on(input, 'input', apply);
    on(clear, 'click', function () { input.value = ''; apply(); input.focus(); });
    $$('[data-faq-cat]').forEach(function (b) {
      on(b, 'click', function () {
        cat = b.dataset.faqCat;
        $$('[data-faq-cat]').forEach(function (o) {
          var isOn = o === b;
          o.classList.toggle('is-on', isOn);
          o.setAttribute('aria-selected', String(isOn));
        });
        apply();
      });
    });
    on(expand, 'click', function () {
      var opening = expand.textContent.trim() === 'Expand all';
      items.forEach(function (it) {
        if (it.classList.contains('is-hidden')) return;
        it.classList.toggle('is-open', opening);
        $('.f-acc__btn', it).setAttribute('aria-expanded', String(opening));
        $('.f-acc__sign', it).textContent = opening ? '−' : '+';
      });
      expand.textContent = opening ? 'Collapse all' : 'Expand all';
    });
    apply();
  })();

  /* --- Product: gallery, pricing, sticky bar, add to cart ----------------- */
  (function product() {
    var root = $('[data-product]');
    if (!root) return;

    var BAG_LBS = parseFloat(root.dataset.bagLbs || '9');
    var hasPlans = root.dataset.hasPlans === 'true';

    /* Gallery ------------------------------------------------------------- */
    var gal = $('[data-gallery]', document);
    var slides = $$('.f-gal__img', gal);
    var thumbsWrap = $('[data-thumbs]');
    var thumbs = $$('[data-thumb]', thumbsWrap);
    var badge = $('[data-gallery-badge]');
    var idx = 0;

    function show(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      if (i === idx) return;
      idx = i;
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-on', n === i);
        t.setAttribute('aria-selected', String(n === i));
      });
      if (badge) badge.style.display = i === 0 ? '' : 'none';
      centreThumb(i);
    }
    // Measure against the scroll container, not offsetLeft (README §Thumbnail rail).
    function centreThumb(i) {
      var el = thumbsWrap, b = thumbs[i];
      if (!el || !b) return;
      var left = b.getBoundingClientRect().left - el.getBoundingClientRect().left + el.scrollLeft;
      el.scrollTo({ left: left - (el.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, n) { on(t, 'click', function () { show(n); }); });

    // Pointer swipe: 36px horizontal, and at least 1.2x the vertical delta.
    var sw = null;
    on(gal, 'pointerdown', function (e) {
      sw = { x: e.clientX, y: e.clientY };
      try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) {}
    });
    function endSwipe(e) {
      var s = sw; sw = null;
      if (!s) return;
      var dx = e.clientX - s.x, dy = e.clientY - s.y;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      show(dx < 0 ? idx + 1 : idx - 1);
    }
    on(gal, 'pointerup', endSwipe);
    on(gal, 'pointercancel', function () { sw = null; });
    on(gal, 'keydown', function (e) {
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });

    /* State --------------------------------------------------------------- */
    var packs = $$('[data-pack]', root);
    var state = {
      pack: parseInt(root.dataset.defaultPack || '3', 10),
      plan: hasPlans ? 'sub' : 'one',
      planId: (($('[data-selling-plan]') || {}).value) || ''
    };

    function packEl(n) {
      return packs.filter(function (p) { return parseInt(p.dataset.pack, 10) === n; })[0];
    }
    function packData(n) {
      var el = packEl(n);
      if (!el) return null;
      var d = {
        el: el,
        variant: el.dataset.variant,
        price: parseInt(el.dataset.price, 10) || 0,
        planPrice: parseInt(el.dataset.planPrice, 10) || 0,
        planRecurring: parseInt(el.dataset.planRecurring, 10) || 0
      };
      // "planId:firstPrice:recurring,…" — use the selected plan's own prices,
      // since plans in a group need not share a discount.
      (el.dataset.planMap || '').split(',').forEach(function (row) {
        var p = row.split(':');
        if (p.length < 3 || p[0] !== state.planId) return;
        d.planPrice = parseInt(p[1], 10) || d.planPrice;
        d.planRecurring = parseInt(p[2], 10) || d.planRecurring;
      });
      return d;
    }
    // Subscription apps name plans all sorts of ways — "Every 4 weeks",
    // "Deliver every 4 weeks", "4 weeks", "Monthly". Pull the interval out of
    // whatever we are given rather than blindly prefixing "every", which turned
    // "Deliver every 4 weeks" into "Ships every deliver every 4 weeks".
    function planLabel() {
      var sel = $('[data-selling-plan]');
      if (!sel || !sel.options.length) return 'every 4 weeks';
      var name = sel.options[sel.selectedIndex].text.trim();
      var every = name.match(/every\s+\d+\s+\S+/i);          // "…every 4 weeks…"
      if (every) return every[0].toLowerCase();
      if (/^\d/.test(name)) return 'every ' + name.toLowerCase();   // "4 weeks"
      return name.toLowerCase();                                     // "monthly"
    }
    function shipLine() { return 'Ships ' + planLabel(); }

    /* Pack shot ------------------------------------------------------------
       Slide 0 and its thumbnail are swapped to the shot matching the selected
       pack. Preloading first means the swap lands on an already-decoded image
       instead of flashing empty. */
    var shotCache = {};
    function swapPackShot(n) {
      var shots = CFG.packShots || {};
      var s = shots[String(n)];
      var img = $('[data-packshot]');
      if (!s || !img) return;
      if (img.getAttribute('src') === s.w1000) return;      // already showing it

      var apply = function () {
        img.srcset = s.w400 + ' 400w, ' + s.w600 + ' 600w, ' + s.w800 + ' 800w, ' + s.w1000 + ' 1000w';
        img.src = s.w1000;
        var base = (root.querySelector('.f-ttl__h1') || {}).textContent || 'Kind Litter';
        img.alt = base.trim() + ' — ' + n + ' pack';
        var th = $('[data-packshot-thumb]');
        if (th) th.src = s.thumb;
      };

      if (shotCache[n]) return apply();
      var pre = new Image();
      pre.onload = pre.onerror = function () { shotCache[n] = true; apply(); };
      pre.src = s.w1000;
    }

    /* Render -------------------------------------------------------------- */
    function render() {
      var sub = state.plan === 'sub' && hasPlans;

      // Pack cards
      packs.forEach(function (el) {
        var n = parseInt(el.dataset.pack, 10);
        var d = packData(n);
        var isOn = n === state.pack;
        el.classList.toggle('is-on', isOn);
        el.setAttribute('aria-checked', String(isOn));
        var due = sub ? d.planPrice : d.price;
        var price = $('[data-pack-price]', el);
        var cmp = $('[data-pack-cmp]', el);
        var perBag = $('[data-pack-perbag]', el);
        if (price) price.textContent = money(due);
        if (cmp) cmp.textContent = sub && d.price > due ? money(d.price) : '';
        if (perBag) perBag.textContent = money(Math.round(due / n)) + '/bag';
      });

      var d = packData(state.pack);
      if (!d) return;
      var dueToday = sub ? d.planPrice : d.price;
      var recurring = d.planRecurring;

      // Plan cards
      var subCard = $('[data-plan="sub"]');
      var oneCard = $('[data-plan="one"]');
      if (subCard) {
        subCard.classList.toggle('is-on', sub);
        subCard.setAttribute('aria-checked', String(sub));
      }
      if (oneCard) {
        oneCard.classList.toggle('is-on', !sub);
        oneCard.setAttribute('aria-checked', String(!sub));
      }

      set('[data-sub-first]', money(d.planPrice));
      set('[data-sub-cmp]', d.price > d.planPrice ? money(d.price) : '');
      set('[data-sub-recurring]', money(recurring));
      set('[data-sub-save]', money(d.price - d.planPrice));
      set('[data-one-price]', money(d.price));
      $$('[data-ship-line]').forEach(function (el) { el.textContent = shipLine(); });

      var firstOff = d.price ? Math.round((1 - d.planPrice / d.price) * 100) : 0;
      var refillOff = d.price ? Math.round((1 - recurring / d.price) * 100) : 0;
      var badgeEl = $('[data-sub-badge]');
      if (badgeEl) {
        badgeEl.textContent = firstOff + '% OFF BOX 1';
        badgeEl.style.display = firstOff > 0 ? '' : 'none';
      }
      set('[data-sub-off-line]', refillOff > 0 ? refillOff + '% off every refill' : 'Members-only pricing');

      // Due today + CTA
      set('[data-due-today]', money(dueToday));
      set('[data-then-line]', sub
        ? 'then ' + money(recurring) + ' ' + planLabel() + ' · cancel any time, even after box 1'
        : 'one-time order · no subscription');
      $$('[data-cta-label]').forEach(function (el) { el.textContent = 'Add to cart — ' + money(dueToday); });

      // Lead gallery slide follows the pack selection, so the hero image always
      // shows the number of bags the shopper is actually buying.
      swapPackShot(state.pack);

      // Sticky bar
      set('[data-bar-sub]', state.pack + '-pack · ' + (state.pack * BAG_LBS) + ' lbs');
      var barImg = $('[data-bar-img]');
      if (barImg) barImg.src = barImg.src.replace(/pack-\d/, 'pack-' + state.pack);
      var barPack = $('[data-bar-pack]');
      if (barPack && barPack.value !== String(state.pack)) barPack.value = String(state.pack);
      var barPlan = $('[data-bar-plan]');
      if (barPlan) {
        var want = sub ? state.planId : 'one';
        if (barPlan.value !== want) barPlan.value = want;
      }

      // Form
      var vIn = $('[data-atc-variant]');
      var pIn = $('[data-atc-plan]');
      if (vIn) vIn.value = d.variant;
      if (pIn) pIn.value = sub ? state.planId : '';
    }
    function set(sel, text) { $$(sel).forEach(function (el) { el.textContent = text; }); }

    /* Inputs -------------------------------------------------------------- */
    packs.forEach(function (el) {
      on(el, 'click', function () { state.pack = parseInt(el.dataset.pack, 10); render(); });
    });
    on($('[data-plan="sub"]'), 'click', function (e) {
      if (e.target.closest('select')) return;    // the frequency dropdown is not a plan toggle
      state.plan = 'sub'; render();
    });
    on($('[data-plan="sub"]'), 'keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); state.plan = 'sub'; render(); }
    });
    on($('[data-plan="one"]'), 'click', function () { state.plan = 'one'; render(); });
    on($('[data-selling-plan]'), 'change', function (e) {
      state.planId = e.target.value; state.plan = 'sub'; render();
    });
    on($('[data-bar-pack]'), 'change', function (e) { state.pack = parseInt(e.target.value, 10); render(); });
    on($('[data-bar-plan]'), 'change', function (e) {
      // This one dropdown is what switches plan type in the sticky bar.
      if (e.target.value === 'one') { state.plan = 'one'; }
      else {
        state.plan = 'sub'; state.planId = e.target.value;
        var sel = $('[data-selling-plan]');
        if (sel) sel.value = e.target.value;
      }
      render();
    });

    /* Sticky bar visibility ------------------------------------------------ */
    var bar = $('[data-atc-bar]');
    var anchor = $('[data-cta-anchor]');
    if (bar && anchor) {
      var sync = function () { bar.classList.toggle('is-on', anchor.getBoundingClientRect().bottom < 10); };
      on(window, 'scroll', sync, { passive: true });
      on(window, 'resize', sync);
      sync();
    }

    /* Add to cart ---------------------------------------------------------- */
    var form = $('[data-atc-form]');
    function addToCart(btn) {
      var vIn = $('[data-atc-variant]'), pIn = $('[data-atc-plan]');
      var body = { items: [{ id: Number(vIn.value), quantity: 1 }] };
      if (pIn && pIn.value) body.items[0].selling_plan = Number(pIn.value);
      if (btn) btn.disabled = true;
      // Open first, fill after. Waiting on add + /cart.js before showing the
      // drawer made the button feel dead for a whole round trip on mobile.
      Cart.open(true);
      fetch(CFG.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return Cart.refresh(); })
        .catch(function (err) {
          // Never leave the shopper stuck: fall through to the real cart page.
          console.error('[furrly] add to cart failed', err);
          window.location.href = CFG.routes.cart;
        })
        .then(function () { if (btn) btn.disabled = false; });
    }
    on(form, 'submit', function (e) { e.preventDefault(); addToCart($('[data-atc-btn]', form)); });
    $$('[data-bar-cta]').forEach(function (b) {
      // Both CTAs call the handler directly (README §Sticky add-to-cart bar).
      on(b, 'click', function () { addToCart(b); });
    });

    render();
  })();

  /* --- Cart drawer -------------------------------------------------------- */
  var Cart = (function () {
    var el = $('[data-cart]');
    var trigger = null;

    var lockQueued = false;
    function setOpen(open) {
      if (!el) return;
      // Re-entrant calls would unbalance the scroll-lock depth counter.
      if (el.classList.contains('is-open') === open) return;
      el.classList.toggle('is-open', open);
      var scrim = $('.f-cart__scrim', el);
      if (scrim) scrim.tabIndex = open ? 0 : -1;

      if (open) {
        // Pinning the body reflows the whole (long) page. Let the slide start
        // on the compositor first, then take the lock a frame later — that is
        // the difference between a drawer that snaps open and one that hitches.
        lockQueued = true;
        requestAnimationFrame(function () {
          if (!lockQueued) return;
          lockQueued = false;
          Lock.on();
        });
        var x = $('.f-cart__x', el);
        if (x) x.focus({ preventScroll: true });
      } else {
        if (lockQueued) lockQueued = false; else Lock.off();
        if (trigger) trigger.focus({ preventScroll: true });
      }
    }

    /* Drawer body -----------------------------------------------------------
       Rendered here from /cart.js rather than through the Section Rendering
       API: `furrly-cart-items` is not part of any JSON template, so
       /?sections=furrly-cart-items answers {"furrly-cart-items":null} and the
       drawer kept showing whatever the page was served with. Mirrors
       snippets/furrly-cart-body.liquid — keep the two in step. */
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function icon(n, cls) {
      return '<svg class="fi' + (cls ? ' ' + cls : '') + '" aria-hidden="true"><use href="#i-' + n + '"></use></svg>';
    }

    // Plans a line could switch to. /cart.js only reports the plan a line is
    // already on, so the alternatives come from Liquid (furrly-cart-drawer).
    function planList(item) {
      var sp = CFG.sellingPlans;
      if (!sp || !sp.byVariant) return [];
      return sp.byVariant[String(item.variant_id || item.id)] || [];
    }
    function currentPlanId(item) {
      return item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null;
    }
    // Ongoing price per delivery. Read the LAST price adjustment, never
    // per_delivery_price: on "50% off box one, then 20%" Shopify reports the
    // intro price in per_delivery_price ($35 on a $70 3-Pack), so the drawer
    // would quote box one's figure as the forever price. The adjustment list
    // carries the real post-intro number ($56). Same rule as the product fold
    // (sections/furrly-product.liquid) and snippets/furrly-cart-body.liquid.
    function planRecurring(alloc) {
      if (!alloc) return 0;
      var adj = alloc.price_adjustments;
      if (adj && adj.length > 1) return adj[adj.length - 1].price;
      return alloc.per_delivery_price;
    }
    // "Deliver every 4 weeks" → "every 4 weeks"
    function everyLabel(name) {
      var m = String(name || '').match(/every\s+.+$/i);
      return (m ? m[0] : String(name || '')).toLowerCase();
    }

    // The design shows the bundled pack renders instead of Shopify media, so
    // match the pack count in the variant title first (as furrly-line-image does).
    // Read the LEADING number, never "contains": this product runs 1-Pack to
    // 12-Pack, and "11-Pack" contains "1 pack" while "12-Pack" contains "2 pack".
    function lineImage(item) {
      var packs = CFG.packImages || {};
      var lead = String(item.variant_title || item.title || '').match(/^\s*(\d+)/);
      var n = lead ? parseInt(lead[1], 10) : 0;
      if (packs[n]) return packs[n];
      return item.image || packs[3] || '';
    }

    function lineHTML(item, i) {
      var line = i + 1;                                   // /cart/change.js is 1-based
      var variant = item.variant_title && item.variant_title.indexOf('Default') === -1
        ? ' · ' + esc(item.variant_title) : '';
      var planId = currentPlanId(item);
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? esc(item.selling_plan_allocation.selling_plan.name) : 'One-time order';
      var img = lineImage(item);
      var plans = planList(item);

      var row = '<span class="f-cart__itrow">' +
        '<span class="f-cart__itim">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(item.title) + '" width="62" height="62" loading="lazy">' : '') +
        '</span>' +
        '<span class="f-cart__ittx">' +
          '<span class="f-cart__ithd">' +
            '<span class="f-cart__itname"><b>' + esc(item.product_title) + variant + '</b>' +
            '<span>' + plan + '</span></span>' +
            '<button class="f-cart__rm" type="button" aria-label="Remove ' + esc(item.title) +
              '" data-line-remove="' + line + '">' + icon('trash-f') + '</button>' +
          '</span>' +
          '<span class="f-cart__itfoot">' +
            '<span class="f-step2">' +
              '<button type="button" aria-label="Decrease quantity" data-line-qty="' + line + '" data-delta="-1">' + icon('minus-f') + '</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" aria-label="Increase quantity" data-line-qty="' + line + '" data-delta="1">' + icon('plus-f') + '</button>' +
            '</span>' +
            '<span class="f-cart__itpr"><b>' + money(item.final_line_price) + '</b>' +
              (item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '') +
            '</span>' +
          '</span>' +
        '</span></span>';

      var freq = '', upsell = '';
      if (plans.length) {
        var id = 'f-freq-' + line;
        freq = '<span class="f-cart__freq">' +
          '<label for="' + id + '">Delivery</label>' +
          '<span class="f-select">' +
            '<select id="' + id + '" data-line-plan="' + line + '" data-qty="' + item.quantity + '">' +
              '<option value=""' + (planId ? '' : ' selected') + '>One-time purchase</option>' +
              plans.map(function (p) {
                return '<option value="' + p.id + '"' + (p.id === planId ? ' selected' : '') + '>' + esc(p.name) + '</option>';
              }).join('') +
            '</select>' + icon('caret-down-f', 'f-select__caret') +
          '</span></span>';

        // One-time line → offer the plan the product fold defaults to.
        if (!planId) {
          var def = CFG.sellingPlans && CFG.sellingPlans.defaultId;
          var up = plans.filter(function (p) { return p.id === def; })[0] || plans[0];
          var save = item.final_line_price - up.first * item.quantity;
          if (save > 0) {
            upsell = '<button class="f-cart__up" type="button" data-line-subscribe="' + line +
                '" data-plan="' + up.id + '" data-qty="' + item.quantity + '">' +
              icon('repeat-f') +
              '<span class="f-cart__uptx">' +
                '<b>Subscribe and save ' + money(save) + ' on this box</b>' +
                '<span>Then ' + money(up.recurring * item.quantity) + ' ' + esc(everyLabel(up.name)) +
                  ' · skip or cancel any time</span>' +
              '</span>' +
              '<span class="f-cart__upgo">Switch</span></button>';
          }
        }
      }

      return '<div class="f-cart__it" data-line="' + line + '">' + row + freq + upsell + '</div>';
    }

    function bodyHTML(cart) {
      if (!cart.item_count) {
        return '<div class="f-cart__empty">' + icon('paw-print-f') + '<b>CART IS EMPTY</b>' +
          '<button class="f-cart__keep" type="button" data-cart-close>Keep shopping</button></div>';
      }

      var saving = cart.original_total_price - cart.total_price;
      var recurring = cart.items.reduce(function (sum, it) {
        return sum + planRecurring(it.selling_plan_allocation) * it.quantity;
      }, 0);

      return cart.items.map(lineHTML).join('') +
        '<div class="f-cart__free">' +
          '<div class="f-cart__freehd"><span>' + icon('gift-f') + 'INCLUDED FREE</span></div>' +
          '<div class="f-cart__freerow">' + icon('truck-f') + '<b>Shipping</b><s>$6.95</s><em>FREE</em></div>' +
          '<div class="f-cart__freerow">' + icon('shield-check-f') + '<b>30-day guarantee</b><em>FREE</em></div>' +
          '<div class="f-cart__freerow">' + icon('map-pin-line-f') + '<b>Delivery tracking</b><em>FREE</em></div>' +
          '<div class="f-cart__freerow">' + icon('receipt-f') + '<b>Taxes and fees</b><em>NONE</em></div>' +
        '</div>' +
        '<div class="f-cart__sum">' +
          '<span class="f-cart__srow"><span>Subtotal</span><b>' + money(cart.original_total_price) + '</b></span>' +
          (saving > 0 ? '<span class="f-cart__srow f-cart__srow--save"><span>First-box saving</span><b>−' + money(saving) + '</b></span>' : '') +
          '<span class="f-cart__rule"></span>' +
          '<span class="f-cart__tot"><span>TOTAL TODAY</span><b>' + money(cart.total_price) + '</b></span>' +
          (recurring > 0 ? '<span class="f-cart__then">Then ' + money(recurring) +
            ' per delivery · cancel any time, even after box 1</span>' : '') +
        '</div>';
    }

    function refresh() {
      return fetch(CFG.routes.cartUrl, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          var label = $('[data-cart-label]');
          if (label) label.textContent = cart.item_count ? cart.item_count + ' item' + (cart.item_count > 1 ? 's' : '') : '';
          var btn = $('[data-cart-checkout]');
          if (btn) {
            btn.disabled = cart.item_count === 0;
            btn.classList.toggle('is-off', cart.item_count === 0);
            var lab = $('[data-cart-btn-label]', btn);
            if (lab) lab.textContent = cart.item_count ? 'Checkout · ' + money(cart.total_price) : 'Your cart is empty';
          }
          var body = $('[data-cart-body]');
          if (body) body.innerHTML = bodyHTML(cart);
          if (el) el.classList.remove('is-busy');
          return cart;
        })
        .catch(function (err) {
          if (el) el.classList.remove('is-busy');
          console.error('[furrly] cart refresh failed', err);
        });
    }

    /* Line mutations --------------------------------------------------------
       Every change re-renders the body, so a second request fired against the
       old markup would read a stale quantity or line index. One in flight at a
       time; the drawer dims while it runs. */
    var busy = false;
    function change(line, qty, plan) {
      if (busy) return Promise.resolve();
      busy = true;
      if (el) el.classList.add('is-busy');
      // Per the Cart API: identify by `line` only, and always send `quantity`.
      var body = { line: line, quantity: qty };
      if (plan !== undefined) body.selling_plan = plan || null;
      return fetch(CFG.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(refresh)
        .catch(function (err) { console.error('[furrly] cart change failed', err); return refresh(); })
        .then(function () { busy = false; if (el) el.classList.remove('is-busy'); });
    }

    if (el) {
      $$('[data-cart-close]', el).forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && el.classList.contains('is-open')) setOpen(false);
      });
      // Delegated so it survives the drawer body being re-rendered.
      on(el, 'click', function (e) {
        var q = e.target.closest('[data-line-qty]');
        if (q) {
          var line = parseInt(q.dataset.lineQty, 10);
          var row = q.closest('[data-line]');
          var cur = parseInt($('.f-step2 span', row).textContent, 10) || 1;
          change(line, Math.max(0, cur + parseInt(q.dataset.delta, 10)));
          return;
        }
        var rm = e.target.closest('[data-line-remove]');
        if (rm) { change(parseInt(rm.dataset.lineRemove, 10), 0); return; }
        // One-tap subscribe upsell on a one-time line.
        var sub = e.target.closest('[data-line-subscribe]');
        if (sub) {
          change(parseInt(sub.dataset.lineSubscribe, 10),
                 parseInt(sub.dataset.qty, 10) || 1,
                 parseInt(sub.dataset.plan, 10));
          return;
        }
        var keep = e.target.closest('[data-cart-close]');
        if (keep) setOpen(false);
      });

      // Delivery-frequency selector. "" removes the plan (one-time purchase).
      on(el, 'change', function (e) {
        var sel = e.target.closest('[data-line-plan]');
        if (!sel) return;
        change(parseInt(sel.dataset.linePlan, 10),
               parseInt(sel.dataset.qty, 10) || 1,
               sel.value ? parseInt(sel.value, 10) : null);
      });
    }

    $$('[data-cart-open]').forEach(function (b) {
      on(b, 'click', function (e) {
        if (!el) return;               // no drawer on this page — let the link go to /cart
        e.preventDefault();
        trigger = b;
        setOpen(true);
        refresh();
      });
    });

    return {
      // `pending` dims the body until the follow-up refresh lands, so an
      // instantly-opened drawer doesn't show a stale line for a beat.
      open: function (pending) {
        if (pending && el) el.classList.add('is-busy');
        setOpen(true);
      },
      refresh: refresh
    };
  })();

  /* --- Reviews ------------------------------------------------------------ */
  (function reviews() {
    var sec = $('[data-reviews]');
    if (!sec || !CFG.reviewsUrl) return;

    var CATS = [
      ['Odor control', /odor|odour|smell|stink|stench|scent/i],
      ['Easy clumping', /clump/i],
      ['Low tracking', /track/i],
      ['Low dust', /dust/i],
      ['Value for money', /worth|value|price|expensive|cost|pricey/i]
    ];
    var PER = parseInt(sec.dataset.perPage, 10) || 8;
    var rows = [], page = 1, opened = {};

    function relDate(d) {
      var t = Date.parse(d);
      if (isNaN(t)) return '';
      var days = Math.round((Date.now() - t) / 86400000);
      if (days < 30) return days < 2 ? 'Yesterday' : days + ' days ago';
      var m = Math.round(days / 30.4);
      if (m < 12) return m + (m === 1 ? ' month ago' : ' months ago');
      var y = Math.floor(m / 12);
      return y + (y === 1 ? ' year ago' : ' years ago');
    }
    var fmtN = function (n) { return n.toLocaleString('en-US'); };
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function star(cls) {
      return '<svg class="fi' + (cls ? ' ' + cls : '') + '" aria-hidden="true"><use href="#i-star-f"></use></svg>';
    }

    function render() {
      var n = rows.length;
      if (!n) return;
      var avg = rows.reduce(function (a, r) { return a + r.s; }, 0) / n;
      var five = rows.filter(function (r) { return r.s === 5; }).length;
      var score = (Math.round(avg * 100) / 100).toFixed(2);

      $$('[data-rv-score]').forEach(function (e) { e.textContent = score; });
      $$('[data-rv-count]').forEach(function (e) { e.textContent = fmtN(n); });
      // innerHTML is safe here: every interpolated value is a number we computed,
      // never free text out of the dataset.
      $$('[data-rv-subline]').forEach(function (e) {
        e.innerHTML = '<b>' + fmtN(n) + '</b> cat parents rated it <b>' + score + '</b> out of 5';
      });
      $$('[data-rv-reassure]').forEach(function (e) {
        e.innerHTML = '<b>' + fmtN(five) + '</b> of them gave it a full five stars';
      });

      var dist = $('[data-rv-dist]');
      if (dist) {
        dist.innerHTML = [5, 4, 3, 2, 1].map(function (s) {
          var c = rows.filter(function (r) { return r.s === s; }).length;
          var p = Math.round(c / n * 100) + '%';
          return '<div class="f-rv__bar"><b>' + s + '★</b>' +
            '<span class="f-rv__track"><span class="f-rv__fill" style="width:' + p + '"></span></span>' +
            '<span>' + p + '</span></div>';
        }).join('');
      }

      var cats = $('[data-rv-cats]');
      if (cats) {
        cats.innerHTML = CATS.map(function (c) {
          var hits = rows.filter(function (r) { return c[1].test(r.t); });
          var a = hits.length ? hits.reduce(function (x, r) { return x + r.s; }, 0) / hits.length : 0;
          var p = (a ? Math.round(a / 5 * 100) : 0) + '%';
          return '<span class="f-rv__cat"><b>' + esc(c[0]) + '</b>' +
            '<span class="f-rv__track"><span class="f-rv__fill" style="width:' + p + '"></span></span>' +
            '<span>' + (a ? a.toFixed(1) : '—') + '</span></span>';
        }).join('');
      }

      // Dataset photos lead; the curated CDN tiles rendered by Liquid follow.
      var rail = $('[data-rv-photos]');
      if (rail && !rail.dataset.seeded) {
        var fromData = [];
        rows.forEach(function (r) {
          var list = (r.imgs && r.imgs.length) ? r.imgs : (r.img ? [r.img] : []);
          list.forEach(function (u) { fromData.push({ img: u, n: r.n }); });
        });
        if (fromData.length) {
          rail.insertAdjacentHTML('afterbegin', fromData.map(function (p) {
            return '<span class="f-rv__ph"><img src="' + esc(p.img) + '" alt="Kind Litter photo from ' + esc(p.n) +
              '" width="112" height="149" loading="lazy">' +
              '<span class="f-rv__phcap"><b>' + esc(p.n) + '</b><span>★★★★★</span></span></span>';
          }).join(''));
        }
        rail.dataset.seeded = '1';
      }

      var pages = Math.max(1, Math.ceil(n / PER));
      if (page > pages) page = pages;
      var from = (page - 1) * PER;

      var cards = $('[data-rv-cards]');
      if (cards) {
        cards.innerHTML = rows.slice(from, from + PER).map(function (r, idx) {
          var i = from + idx;                       // key by absolute index so
          var open = !!opened[i];                   // "read more" survives paging
          var stars = [1, 2, 3, 4, 5].map(function (k) { return star(k <= r.s ? 'on' : ''); }).join('');
          return '<div class="f-rv__card' + (r.__feat ? ' is-featured' : '') + '">' +
            (r.__feat ? '<span class="f-rv__badge"><svg class="fi" aria-hidden="true"><use href="#i-sparkle-f"></use></svg>Featured</span>' : '') +
            '<span class="f-rv__chd"><span class="f-rv__cpaws" role="img" aria-label="' + r.s + ' out of 5">' + stars + '</span>' +
            '<span class="f-rv__cdate">' + esc(relDate(r.d)) + '</span></span>' +
            (r.title ? '<span class="f-rv__ctitle">' + esc(r.title) + '</span>' : '') +
            '<span class="f-rv__cbody' + (open ? ' is-open' : '') + '">' + esc(r.t) + '</span>' +
            (r.t.length > 240 ? '<button class="f-rv__more" type="button" data-rv-toggle="' + i + '">' +
              (open ? 'Show less' : 'Read more') + '</button>' : '') +
            '<span class="f-rv__who"><span class="f-rv__av">' + esc((r.n || '?').trim().charAt(0).toUpperCase()) + '</span>' +
            '<span class="f-rv__whotx"><span class="f-rv__name">' + esc(r.n) +
            (r.v === false ? '' : '<svg class="fi" aria-hidden="true"><use href="#i-check-circle-f"></use></svg>') + '</span>' +
            (r.loc ? '<span class="f-rv__loc">' + esc(r.loc) + '</span>' : '') +
            '</span></span></div>';
        }).join('');
      }

      renderPager(pages, n, from);

      var all = $('[data-rv-all]');
      if (all) all.textContent = 'Read all ' + fmtN(n) + ' reviews';
    }

    // Windowed pager: first and last always reachable, the current page flanked
    // by one either side, gaps elided. 634 reviews should not print 80 buttons.
    function renderPager(pages, total, from) {
      var pager = $('[data-rv-pager]');
      if (!pager) return;
      pager.hidden = pages <= 1;
      if (pages <= 1) { pager.innerHTML = ''; return; }

      var want = [1, pages, page, page - 1, page + 1];
      if (page <= 3) want.push(2, 3);
      if (page >= pages - 2) want.push(pages - 1, pages - 2);
      var list = want.filter(function (p, i, a) { return p >= 1 && p <= pages && a.indexOf(p) === i; })
        .sort(function (a, b) { return a - b; });

      var html = '<button class="f-pager__nav" type="button" data-rv-page="' + (page - 1) + '"' +
        (page === 1 ? ' disabled' : '') + ' aria-label="Previous page">' +
        '<svg class="fi" aria-hidden="true"><use href="#i-caret-left-f"></use></svg></button>';
      list.forEach(function (p, i) {
        if (i && p - list[i - 1] > 1) html += '<span class="f-pager__gap" aria-hidden="true">…</span>';
        html += '<button class="f-pager__n' + (p === page ? ' is-on' : '') + '" type="button" data-rv-page="' + p + '"' +
          (p === page ? ' aria-current="page"' : '') + ' aria-label="Page ' + p + ' of ' + pages + '">' + p + '</button>';
      });
      html += '<button class="f-pager__nav" type="button" data-rv-page="' + (page + 1) + '"' +
        (page === pages ? ' disabled' : '') + ' aria-label="Next page">' +
        '<svg class="fi" aria-hidden="true"><use href="#i-caret-right-f"></use></svg></button>';
      html += '<span class="f-pager__count">' + (from + 1) + '&ndash;' +
        Math.min(from + PER, total) + ' of ' + fmtN(total) + '</span>';
      pager.innerHTML = html;
    }

    on(sec, 'click', function (e) {
      var b = e.target.closest('[data-rv-page]');
      if (!b || b.disabled) return;
      var next = parseInt(b.dataset.rvPage, 10);
      if (!next || next === page) return;
      page = next;
      render();
      // Land at the top of the section, not mid-list.
      var top = sec.getBoundingClientRect().top + window.scrollY - 60;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
    on(sec, 'click', function (e) {
      var t = e.target.closest('[data-rv-toggle]');
      if (!t) return;
      var i = t.dataset.rvToggle;
      opened[i] = !opened[i];
      render();
    });

    fetch(CFG.reviewsUrl)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!Array.isArray(d) || !d.length) return;

        // Featured: reviews carrying "f":1 in the dataset — hand-picked
        // long-form ones, pinned to the top of page 1. Re-pick by moving the
        // flag in furrly-reviews.json; nothing here needs editing.
        var featured = d.filter(function (r) { return r.f; })
          .sort(function (a, b) { return b.t.length - a.t.length; });
        featured.forEach(function (r) { r.__feat = true; });

        // The same review reaches us from more than one source (site + Amazon)
        // with light wording drift, so match on a normalised opening rather
        // than the full text — a pinned card must not sit beside its own twin.
        function stem(r) { return r.t.replace(/\s+/g, ' ').trim().slice(0, 100).toLowerCase(); }
        var featStems = {};
        featured.forEach(function (r) { featStems[stem(r)] = true; });

        var rest = d.filter(function (r) { return !r.f; })
          .sort(function (a, b) { return (Date.parse(b.d) || 0) - (Date.parse(a.d) || 0); });
        var fresh = rest.filter(function (r) { return !featStems[stem(r)]; });
        var echoes = rest.filter(function (r) { return featStems[stem(r)]; });

        rows = featured.concat(fresh, echoes);
        render();
      })
      .catch(function (err) { console.error('[furrly] reviews failed to load', err); });
  })();

  /* --- Contact form ------------------------------------------------------- */
  (function contact() {
    var fields = $('[data-contact-form-fields]');
    var form = fields && fields.closest('form');
    if (!form) return;

    // Topic chips write into the hidden contact[Topic] field.
    var topicInput = $('[data-topic-input]', form);
    $$('[data-topic]', form).forEach(function (chip) {
      on(chip, 'click', function () {
        $$('[data-topic]', form).forEach(function (o) {
          var isOn = o === chip;
          o.classList.toggle('is-on', isOn);
          o.setAttribute('aria-checked', String(isOn));
        });
        if (topicInput) topicInput.value = chip.dataset.topic;
      });
    });

    var body = $('textarea[data-validate="body"]', form);
    var counter = $('[data-count]', form);
    if (body && counter) {
      var max = body.getAttribute('maxlength') || 1000;
      var tick = function () { counter.textContent = body.value.length + ' / ' + max; };
      on(body, 'input', tick);
      tick();
    }

    var rules = {
      name: 'Tell us what to call you',
      email: 'We need a valid email to reply',
      body: 'A sentence or two, so we can actually help',
      business: 'We need the name of the business'
    };
    function check(field) {
      var wrap = field.closest('.f-field');
      var key = field.dataset.validate;
      var v = field.value.trim();
      var ok = key === 'email' ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) : v.length > (key === 'body' ? 4 : 0);
      wrap.classList.toggle('is-bad', !ok);
      var err = $('.f-field__err span', wrap);
      if (err) err.textContent = rules[key] || 'Please check this field';
      return ok;
    }
    $$('[data-validate]', form).forEach(function (f) {
      on(f, 'blur', function () { if (f.value.trim()) check(f); });
      on(f, 'input', function () {
        if (f.closest('.f-field').classList.contains('is-bad')) check(f);
      });
    });
    on(form, 'submit', function (e) {
      var ok = $$('[data-validate]', form).map(check).every(Boolean);
      if (!ok) {
        e.preventDefault();
        var bad = $('.f-field.is-bad [data-validate]', form);
        if (bad) bad.focus();
      }
    });
  })();
})();
